import * as React from 'react';
import PremiumPricingGuide from '../../Teacher/containers/PremiumPricingGuide';

const PremiumPricingGuideApp = (props) => (
  <PremiumPricingGuide {...props} />
);

export default PremiumPricingGuideApp
